import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound, ShieldCheck } from "lucide-react";

const AdminLogin = ({ onSuccess }) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) {
      toast.error("Lütfen şifreyi girin");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { password });
      if (data.success) {
        sessionStorage.setItem("sahder_admin", "1");
        sessionStorage.setItem("sahder_admin_pw", password);
        toast.success("Hoş geldiniz");
        onSuccess?.();
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Hatalı şifre");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto animate-fade-up" data-testid="admin-login">
      <div className="relative bg-white rounded-2xl border border-stone-200 shadow-lg p-8 overflow-hidden">
        <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-[#D4AF37]/10 blur-2xl pointer-events-none" />
        <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full bg-[#8A252C]/10 blur-2xl pointer-events-none" />

        <div className="relative">
          <div className="w-14 h-14 rounded-full bg-[#8A252C] text-white flex items-center justify-center mx-auto shadow-md ring-4 ring-[#D4AF37]/30">
            <ShieldCheck className="w-6 h-6" />
          </div>
          <h2 className="font-display text-3xl font-bold text-[#1F2937] text-center mt-5">
            Yönetici Girişi
          </h2>
          <p className="text-center text-sm text-[#4B5563] mt-1">
            Etkinlikleri onaylamak için şifrenizi girin
          </p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-4">
            <div className="space-y-2">
              <Label htmlFor="admin-password" className="text-[11px] uppercase tracking-[0.18em] text-[#8A252C]/80 font-bold">
                Yönetici Şifresi
              </Label>
              <div className="relative">
                <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#4B5563]" />
                <Input
                  id="admin-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  data-testid="admin-password-input"
                  className="bg-stone-50 border-stone-300 h-11 pl-9"
                />
              </div>
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="admin-login-btn"
              className="w-full bg-[#8A252C] hover:bg-[#6f1d24] text-white h-11 shadow-sm"
            >
              {loading ? "Doğrulanıyor..." : "Giriş Yap"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
